module.exports = __webpack_public_path__ + "fonts/fa-regular-400.232215c73ce36816d36c5d9ae76e38fa.eot";